
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.555 12.844v6.045A1.1 1.1 0 0118.445 20H1.554a1.1 1.1 0 01-1.11-1.111v-6.045a1.1 1.1 0 011.11-1.11 1.1 1.1 0 011.112 1.11v4.934h14.666v-4.934a1.1 1.1 0 011.111-1.11 1.1 1.1 0 011.111 1.11zM9.2 14.222c.2.222.489.334.8.334.311 0 .578-.112.8-.334l4.422-4.533A1.12 1.12 0 0015.2 8.11a1.12 1.12 0 00-1.578.022l-2.511 2.6V1.111A1.1 1.1 0 0010 0a1.1 1.1 0 00-1.111 1.111v9.622L6.355 8.156c-.422-.445-1.133-.445-1.577-.023-.445.423-.445 1.134-.023 1.578L9.2 14.222z","fill":"#ABAFB5"}})])
          )
        }
      }
    